export { default } from "./SpeedDial.mjs";
export { default as speedDialClasses } from "./speedDialClasses.mjs";
export * from "./speedDialClasses.mjs";